import angular from 'angular';
import constants from 'app/constants';
import {
  pmDataService,
  loaderService,
  ssDialogService,
  pmSharedModelService
} from 'app/services';
import { alerts } from 'app/components/global';
import documentNameMessagesTpl from './messages/document.name.messages.html';
import validator, { name as validatorName } from './messages/document-unique-name.validator.directive';
import controller from './edit-document-dialog.controller';
import template from './edit-document-dialog.html';
import newRecommendedChangesDialog from '../dialog.newRecommendedChangesDialog';

class dialogService {
  getOptions($event, { document, settings }) {
    return {
      controller,
      controllerAs: 'editPmDocumentDialogVM',
      locals: {
        document,
        settings
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pm.editPmDocumentDialog', [
  alerts,
  pmDataService,
  loaderService,
  constants,
  ssDialogService,
  newRecommendedChangesDialog,
  pmSharedModelService
])
  .directive(validatorName, validator)
  .service('editPmDocumentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('pm-document.name.messages.html', documentNameMessagesTpl);
  })
  .name;
